const canUseBrowserStorage = () =>
  typeof window !== "undefined" &&
  typeof window.localStorage !== "undefined" &&
  typeof window.sessionStorage !== "undefined";

export const safeLocalStorageGet = (key: string): string | null => {
  if (!canUseBrowserStorage()) return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const safeLocalStorageSet = (key: string, value: string) => {
  if (!canUseBrowserStorage()) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Ignore storage permission/quota errors in restricted webviews.
  }
};

export const safeLocalStorageRemove = (key: string) => {
  if (!canUseBrowserStorage()) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ignore storage permission/quota errors in restricted webviews.
  }
};

export const safeSessionStorageGet = (key: string): string | null => {
  if (!canUseBrowserStorage()) return null;
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const safeSessionStorageSet = (key: string, value: string) => {
  if (!canUseBrowserStorage()) return;
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // Ignore storage permission/quota errors in restricted webviews.
  }
};

export const safeSessionStorageRemove = (key: string) => {
  if (!canUseBrowserStorage()) return;
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Ignore storage permission/quota errors in restricted webviews.
  }
};
